import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';

/**
 * Returns item ids of all nodes in a conversation
 * @param conversationId
 */
export default function getItemIdsFromConversation(conversationId: string): string[] {
    const { conversations, conversationNodes } = getMailStore();
    const conversationItemParts = conversations?.get(conversationId);
    const conversationNodeIds = conversationItemParts?.conversationNodeIds || [];
    const allItemIds = [];

    conversationNodes &&
        conversationNodeIds.forEach(conversationNodeId => {
            const conversationNode = conversationNodes.get(conversationNodeId);
            const itemIds = conversationNode?.itemIds || [];
            itemIds.forEach(id => {
                allItemIds.push(id);
            });
        });

    return allItemIds;
}
